// extracted by mini-css-extract-plugin
module.exports = {"partnerPageFooter":"Footer_partnerPageFooter__yVq7X","title":"Footer_title__f84MU","buttonGroup":"Footer_buttonGroup__qyv6b"};